<template>
  <div class="rich-text-editor-container">
    <b-field :label="label">
      <div v-html="value" v-once class="editor textarea-like"></div>
    </b-field>
  </div>
</template>

<script>
export default {
  name: 'DisplayRichTextEditorLight',
  props: {
    value: { type: String, default: '' }, // pre-rendered HTML
    label: { type: String, default: '' },
  },
};
</script>

<style scoped>
/* Use ::v-deep for content inserted via v-html so scoped styles apply */
::v-deep(.editor) {
  max-height: 400px;
  overflow-y: auto;
  font-family: inherit;
  text-align: left;
  padding: 0.25rem;
}

/* Target headings inside the editor */
::v-deep(.editor h1) {
  font-size: 1.6rem;
}
::v-deep(.editor h2) {
  font-size: 1.4rem;
}
::v-deep(.editor h3) {
  font-size: 1.2rem;
}

/* Lists */
::v-deep(.editor ul) {
  list-style-type: disc !important;
  padding-left: 2rem !important;
  margin-left: 1rem !important;
}
::v-deep(.editor ol) {
  list-style-type: decimal !important;
  padding-left: 2rem !important;
  margin-left: 1rem !important;
}
::v-deep(.editor li) {
  list-style: inherit !important;
  display: list-item !important;
}

.rich-text-editor-container {
  width: 100%;
}
</style>
